import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function PrivateRoute({ children, roles }) {
  const { currentUser, effectiveRole, loading } = useAuth();

  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(effectiveRole)) {
    return <Navigate to={getRoleHome(effectiveRole)} replace />;
  }

  return children;
}

export function getRoleHome(role) {
  switch (role) {
    case 'driver':   return '/driver';
    case 'orderer':  return '/orderer';
    case 'admin':    return '/admin';
    case 'carrier':  return '/transportor';
    default:         return '/login';
  }
}
